export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6804.c8063234.jpg";